import de from "./de";
import en from "./en";

export const CHECKIN_LANGUAGE_STORAGE_KEY = "preferred-checkin-language";

const translations = { de, en };

export const normalizeCheckinLanguage = (value) => {
  const language = String(value || "").trim().toLowerCase();

  if (language.startsWith("en")) return "en";
  if (language.startsWith("de")) return "de";

  return "de";
};

const readPath = (source, path) =>
  path.split(".").reduce((value, key) => value?.[key], source);

export const getCheckinTranslator = (language) => {
  const normalizedLanguage = normalizeCheckinLanguage(language);
  const dictionary = translations[normalizedLanguage] || translations.de;

  return (key, replacements = {}) => {
    const template = readPath(dictionary, key) ?? readPath(translations.de, key) ?? key;

    if (typeof template !== "string") {
      return key;
    }

    return Object.entries(replacements).reduce(
      (result, [name, value]) => result.replaceAll(`{${name}}`, value ?? ""),
      template
    );
  };
};

export const localizeKnownOption = (group, option, language) => {
  const value = option?.value;
  const label = readPath(translations[normalizeCheckinLanguage(language)], `${group}.${value}`);

  return {
    ...option,
    label: label || option?.label || value,
  };
};
